import { useGetAuthenticatedUser } from "../../app/-components/use-authenticated-user"
import { Stack, Text } from "@mantine/core"
import { ChatDto } from "@/orval/gen/model"
import { PersonLink } from "@/routes/app/art/activities/-components/-tabs/CastsTab/person-links"
import { PersonNameWithUserNameFallback } from "./ChatListForCurrentUser/PersonNameWithUserNameFallback"

interface Props {
  chat: ChatDto
}

export function ChatName({ chat }: Props) {
  if (chat.chatType === "Direct") {
    return (
      <Text size="lg">
        <DirectChatName chat={chat} />
      </Text>
    )
  }
  return (
    <Stack gap={0}>
      <Text size="lg">{chat.name}</Text>
      <Text c="dimmed" size="xs" lineClamp={1}>
        {chat.description}
      </Text>
    </Stack>
  )
}

function DirectChatName({ chat }: Props) {
  const currentUserId = useGetAuthenticatedUser().data.userId
  const chatMember =
    chat.chatMembers.find((cm) => cm.userId !== currentUserId) ??
    chat.chatMembers[0]
  if (!chatMember) throw new Error("No chat members found for direct chat")

  return chatMember.personId ? (
    <PersonLink personId={chatMember.personId} />
  ) : (
    <PersonNameWithUserNameFallback userId={chatMember.userId} />
  )
}
